export default {
  loading: false,
  pages: [],
  usersActivity: [],
};
